import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useRouteMatch } from 'react-router';

import { config } from 'src/config';
import { isBrowser } from 'src/shared/helpers/environment';
import { useNonce } from 'src/shared/hooks';
import { Route } from 'src/shared/route';

import { snippet } from './snippet';

const Gtm = () => {
  const nonce = useNonce();

  const isRouteAllowed = [
    useRouteMatch(Route.SIGN_UP.path),
    useRouteMatch(Route.SIGN_UP_PROFESSIONAL),
    useRouteMatch(Route.SIGN_UP_HOMEOWNER),
    useRouteMatch(Route.SIGN_UP_PROFESSIONAL_PROMOTION_FB_20.path),
    useRouteMatch(Route.SIGN_UP_PROFESSIONAL_PROMOTION_FB_40.path),
    useRouteMatch(Route.SIGN_UP_PROFESSIONAL_PROMOTION_FB_60.path),
    useRouteMatch(Route.SIGN_UP_PROFESSIONAL_PROMOTION_FB_75.path),
    useRouteMatch(Route.LOGIN),
    useRouteMatch(Route.AI_DESIGNER.path),
  ].some(match => !!match);
  const isAnalyticsAvailable = isBrowser() && window?.analytics;

  if (!config.NEW_GTM_API_KEY || isAnalyticsAvailable || !isRouteAllowed)
    return null;

  return (
    <Helmet>
      <script nonce={nonce}>{snippet(config.NEW_GTM_API_KEY)}</script>
    </Helmet>
  );
};

export { Gtm };
